// Tier access configuration — single source of truth for plan-based feature gating

export const TIER_ORDER = ['starter', 'growth', 'enterprise'];

const OPERATIONAL_PAGES = ['/pos', '/sales-history', '/purchases', '/purchases/history', '/credit-customers'];
const DASHBOARD_PAGES   = ['/dashboard', '/savings', '/smart-actions', '/customer-insights'];
const REPORT_PAGES      = ['/reports', '/accounting'];

export const TIER_ACCESS = {
  starter: {
    pages: ['/stock', '/appendix', '/settings', ...OPERATIONAL_PAGES],
    smartActionsInStock: false,
  },
  growth: {
    pages: ['/stock', '/appendix', '/settings', ...OPERATIONAL_PAGES, ...DASHBOARD_PAGES],
    smartActionsInStock: true,
  },
  enterprise: {
    pages: ['/stock', '/appendix', '/settings', ...OPERATIONAL_PAGES, ...DASHBOARD_PAGES, ...REPORT_PAGES],
    smartActionsInStock: true,
  },
};

// Unknown/null tiers (including legacy 'trial') default to 'starter'
export const normaliseTier = (tier) =>
  (TIER_ACCESS[tier] ? tier : 'starter');

export const TIER_UPGRADE_MSG = {
  '/smart-actions':     'Upgrade to Growth to unlock Smart Actions',
  '/customer-insights': 'Upgrade to Growth to unlock Customer Insights',
  '/dashboard':         'Upgrade to Growth to unlock Dashboard',
  '/savings':           'Upgrade to Growth to unlock Dashboard & Savings',
  '/reports':           'Upgrade to Enterprise to unlock Advanced Reports',
  '/accounting':        'Upgrade to Enterprise to unlock Accounting & GST',
};

/**
 * Derive the effective subscription status from the two stored fields.
 * Priority: suspended > date-expired → expired > else → active
 * 'expired' is never stored in DB — always derived from valid_until.
 *
 * @param {string} storedStatus - value from membership_status field ('active' | 'suspended')
 * @param {string|null} validUntil - ISO date string from membership_valid_until
 * @returns {'active' | 'suspended' | 'expired'}
 */
export const computeEffectiveStatus = (storedStatus, validUntil) => {
  if (storedStatus === 'suspended') return 'suspended';
  if (validUntil) {
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (new Date(validUntil) < today) return 'expired';
    } catch (_) {}
  }
  return 'active';
};
